<router-outlet></router-outlet>
<app-footer *ngIf="isLogged" class="footer dark:bg-gray-800"></app-footer>
